export default __webpack_public_path__ + "static/media/logo2.72d97069.PNG";